import axios from 'axios'
import url from './Url'

class product extends url {
    constructor() {
        super()
    }

    getOnlyProdCar = (id, idProdutoEstoque) => {
        return axios.get(`${this.url()}/car/${parseInt(id)}/${idProdutoEstoque}`)
            .then(products => {
                return products
            })
            .catch(err => {
                return err
            })
    }

    positiveQtd = (data) => {

        return axios.put(`${this.url()}/car-positive`, data)
            .then(products => {
                return products;
            })
            .catch(err => {
                console.error("Erro ao deletar produto:", err);
                return err;
            });
    }

    deleteProdCar = (data) => {
        return axios.delete(`${this.url()}/car`, { data: data })
            .then(products => {
                return products;
            })
            .catch(err => {
                console.error("Erro ao deletar produto:", err);
                return err;
            });
    }

    addProdCar = (dataAddProdCar) => {

        return axios.post(`${this.url()}/car`, dataAddProdCar)
            .then(products => {
                return products
            })
            .catch(err => {
                return err
            })
    }

    getAllProds = (id) => {
        return axios.get(`${this.url()}/car/${parseInt(id)}`)
            .then(products => {
                return products
            })
            .catch(err => {
                return err
            })
    }

    prodNameLess = (Cod_Cronos) => {

        return axios.get(`${this.url()}/produ-less/${Cod_Cronos}`)
            .then(nome => {

                return nome
            })
            .catch(err => { return err })
    };

    getAllProdsLocalStorage = (id) => {
        const allProds = JSON.parse(localStorage.getItem(`itemCardProd${id}`))
        if (allProds) {
            return allProds
        }
    }
}

export default product;